module.exports = require('react/lib/ReactTestUtils');


//////////////////
// WEBPACK FOOTER
// ../~/react-addons-test-utils/index.js
// module id = 63
// module chunks = 0